//import Moment from "moment";

const getCount = (state) => {
	return state.controleFrotas.length;
}

export default {
	getCount
}